import auth from '@/middleware/auth.js'

export default [
	{
		path: '/'
		,name: 'login'
		,component: () => import('@/modules/dashboard/Index')
		,meta: {
			title: 'SOC | Créditos Bien para Bien'
		}
	}
	,{
		path: '/dashboard'
		,name: 'dashboard'
		,component: () => import('@/modules/dashboard/Index')
		,meta: {
			title: 'SOC | Créditos Bien para Bien'
			,middleware: auth
		}
	}
];